import { render } from "./AsyncImport.vue?vue&type=template&id=e2dcd1d2"
import script from "./AsyncImport.vue?vue&type=script&lang=ts"
export * from "./AsyncImport.vue?vue&type=script&lang=ts"
script.render = render

export default script